RivalIQ.apps.Reports.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    // The slide class/model
    const Slide = models.Slide = Backbone.Model.extend({
        defaults: {
            style: '',
            elements: {
                head: null, // consider title?
                subhead: null // consider subtitle
            }
        },
        getTitle: function () {
            const me = this;
            const style = me.get('style');
            const elements = me.get('elements');

            switch (style) {
            // head
                case Slide.styleTypes.INTRO:
                case Slide.styleTypes.SECTIONAL:
                    return elements.head;

                // title
                case Slide.styleTypes.SINGLE:
                case Slide.styleTypes.COLUMN:
                case Slide.styleTypes.MULTI_SRC:
                    return elements.title;

                // compound
                case Slide.styleTypes.VERSUS_DOUBLE:
                    return `${elements.title} ${elements.secondaryTitle}`;

                // unknown
                default:
                    return null;
            }
        },

        getDataUrl: function () {
            const me = this;
            return me.get('elements').dataUrl;
        }
    });

    // the brand images
    Slide.brandImages = {
        getLarge: function () {
            return `${RivalIQ.state.product.get('urlBasepath')}/images/ppt/titleLogo.png`;
        },
        getSmall: function () {
            return `${RivalIQ.state.product.get('urlBasepath')}/images/ppt/slideLogo.png`;
        },
        // note: the getLarge() and getSmall() methods get overwritten later;
        // thus, the getDefaultLarge() and getDefaultSmall() methods must be
        // exact copies (which will never get overwritten)
        getDefaultLarge: function () {
            return `${RivalIQ.state.product.get('urlBasepath')}/images/ppt/titleLogo.png`;
        },
        getDefaultSmall: function () {
            return `${RivalIQ.state.product.get('urlBasepath')}/images/ppt/slideLogo.png`;
        }
    };

    // The possible slide style types
    Slide.styleTypes = RivalIQ.enums.slideType;

    // The possible slide styles
    Slide.styles = {};

    // the intro slide style/schema
    Slide.styles[Slide.styleTypes.INTRO] = {
        slide: {
            back: 'FFFFFF',
            color: '666666'
        },
        elements: {
            head: {
                type: 'text',
                options: {
                    y: 150,
                    x: 'c',
                    cy: 70,
                    cx: '90%',
                    font_face: 'Arial',
                    font_size: 40,
                    color: '4C545E',
                    bold: false,
                    align: 'left'
                }
            },
            landscapeTitle: {
                type: 'text',
                options: {
                    y: 332,
                    x: 'c',
                    cy: 46,
                    cx: '90%',
                    font_face: 'Arial',
                    font_size: 20,
                    bold: true,
                    align: 'left'
                }
            },
            landscape: {
                type: 'text',
                options: {
                    y: 359,
                    x: 'c',
                    cy: 46,
                    cx: '90%',
                    font_face: 'Arial',
                    font_size: 24,
                    color: '4C545E',
                    bold: false,
                    align: 'left'
                }
            },
            focusCompanyTitle: {
                type: 'text',
                options: {
                    y: 250,
                    x: 'c',
                    cy: 46,
                    cx: '90%',
                    font_face: 'Arial',
                    font_size: 20,
                    bold: true,
                    align: 'left'
                }
            },
            focusCompany: {
                type: 'text',
                options: {
                    y: 277,
                    x: 'c',
                    cy: 46,
                    cx: '90%',
                    font_face: 'Arial',
                    font_size: 24,
                    color: '4C545E',
                    bold: false,
                    align: 'left'
                }
            },
            activeTagTitle: {
                type: 'text',
                options: {
                    y: 414,
                    x: 'c',
                    cy: 46,
                    cx: '90%',
                    font_face: 'Arial',
                    font_size: 20,
                    bold: true,
                    align: 'left'
                }
            },
            activeTag: {
                type: 'text',
                options: {
                    y: 441,
                    x: 'c',
                    cy: 46,
                    cx: '90%',
                    font_face: 'Arial',
                    font_size: 24,
                    color: '4C545E',
                    bold: false,
                    align: 'left'
                }
            },
            date: {
                type: 'text',
                options: {
                    y: 635,
                    x: 'c',
                    cy: 34,
                    cx: '90%',
                    font_face: 'Arial',
                    font_size: 16,
                    bold: false,
                    align: 'left'
                }
            },
            brand: getBrandStyleInfo(true)
        }
    };

    // the sectional slide style/schema
    Slide.styles[Slide.styleTypes.SECTIONAL] = {
        slide: {
            back: 'FFFFFF',
            color: '666666'
        },
        elements: {
            head: {
                type: 'text',
                options: {
                    y: 200,
                    x: 90,
                    cy: 58,
                    cx: '90%',
                    font_face: 'Arial',
                    font_size: 32,
                    color: '4C545E',
                    bold: false,
                    align: 'left'
                }
            },
            square: {
                type: 'shape',
                shapeType: 'rect',
                options: {
                    y: 0,
                    x: 0,
                    cy: 686,
                    cx: 75,
                    line: 'FFFFFF',
                    color: 'FFFFFF',
                    fill: 'FFFFFF'
                }
            },
            brand: getBrandStyleInfo(true)
        }
    };

    // the single slide style/schema
    Slide.styles[Slide.styleTypes.SINGLE] = {
        slide: {
            back: 'FFFFFF',
            color: '666666'
        },
        elements: {
            header: {
                type: 'header',
                options: {
                    y: 27,
                    x: 'c',
                    cy: 52,
                    cx: '95%'
                },
                title: {
                    type: 'text',
                    options: {
                        font_face: 'Arial',
                        font_size: 28,
                        color: '4C545E',
                        bold: false,
                        align: 'left'
                    }
                },
                subtitle: {
                    type: 'text',
                    multislideFormat: '{0} (Slide {1} of {2})',
                    options: {
                        font_face: 'Arial',
                        font_size: 16,
                        bold: false,
                        align: 'left'
                    }
                }
            },
            primaryMetric: {
                type: 'text',
                options: {
                    y: 600,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    bold: true,
                    font_size: 12,
                    align: 'left'
                }
            },
            primaryMetricDescription: {
                type: 'text',
                options: {
                    y: 618,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    font_size: 12,
                    align: 'left'
                }
            },
            dataUrl: {
                type: 'screenshot',
                options: {
                    y: 153,
                    x: 'c',
                    cy: 425,
                    cx: 850
                },
                screenshotOptions: {
                    viewportSize: {
                        width: 800,
                        height: 300
                    },
                    paperSize: {
                        width: '9.50in',
                        height: '4.8in',
                        border: '0in'
                    },
                    zoomFactor: 1.0
                }
            },
            square: {
                type: 'shape',
                shapeType: 'rect',
                options: {
                    y: 570,
                    x: 0,
                    cy: 115,
                    cx: 15,
                    line: 'FFFFFF',
                    color: 'FFFFFF',
                    fill: 'FFFFFF'
                }
            },
            brand: getBrandStyleInfo()
        }
    };

    // splits a single datasource between two columns
    Slide.styles[Slide.styleTypes.COLUMN] = {
        slide: {
            back: 'FFFFFF',
            color: '666666'
        },
        columns: 2,
        elements: {
            header: {
                type: 'header',
                options: {
                    y: 27,
                    x: 'c',
                    cy: 52,
                    cx: '95%'
                },
                title: {
                    type: 'text',
                    options: {
                        font_face: 'Arial',
                        font_size: 28,
                        color: '4C545E',
                        bold: false,
                        align: 'left'
                    }
                },
                subtitle: {
                    type: 'text',
                    multislideFormat: '{0} (Slide {1} of {2})',
                    options: {
                        font_face: 'Arial',
                        font_size: 16,
                        bold: false,
                        align: 'left'
                    }
                }
            },
            primaryMetric: {
                type: 'text',
                options: {
                    y: 600,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    bold: true,
                    font_size: 12,
                    align: 'left'
                }
            },
            primaryMetricDescription: {
                type: 'text',
                options: {
                    y: 618,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    font_size: 12,
                    align: 'left'
                }
            },
            dataUrl: {
                type: 'screenshot',
                columns: [
                    {
                        options: {
                            y: 158,
                            x: 30,
                            cy: 400,
                            cx: 400
                        }
                    },
                    {
                        options: {
                            y: 158,
                            x: 470,
                            cy: 400,
                            cx: 400
                        }
                    }
                ],
                screenshotOptions: {
                    viewportSize: {
                        width: 800,
                        height: 200
                    },
                    paperSize: {
                        width: '4.75in',
                        height: '4.75in',
                        border: '0in'
                    },
                    zoomFactor: 1.0
                }
            },
            square: {
                type: 'shape',
                shapeType: 'rect',
                options: {
                    y: 570,
                    x: 0,
                    cy: 115,
                    cx: 15,
                    line: 'FFFFFF',
                    color: 'FFFFFF',
                    fill: 'FFFFFF'
                }
            },
            brand: getBrandStyleInfo()
        }
    };

    // splits a single datasource between two columns
    Slide.styles[Slide.styleTypes.MULTI_SRC] = {
        slide: {
            back: 'FFFFFF',
            color: '666666'
        },
        elements: {
            header: {
                type: 'header',
                options: {
                    y: 27,
                    x: 'c',
                    cy: 52,
                    cx: '95%'
                },
                title: {
                    type: 'text',
                    options: {
                        font_face: 'Arial',
                        font_size: 28,
                        color: '4C545E',
                        bold: false,
                        align: 'left'
                    }
                },
                subtitle: {
                    type: 'text',
                    multislideFormat: '{0} (Slide {1} of {2})',
                    options: {
                        font_face: 'Arial',
                        font_size: 16,
                        bold: false,
                        align: 'left'
                    }
                }
            },
            primaryMetric: {
                type: 'text',
                options: {
                    y: 600,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    bold: true,
                    font_size: 12,
                    align: 'left'
                }
            },
            primaryMetricDescription: {
                type: 'text',
                options: {
                    y: 618,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    font_size: 12,
                    align: 'left'
                }
            },
            dataUrl0: {
                type: 'screenshot',
                options: {
                    y: 150,
                    x: 30,
                    cy: 533,
                    cx: 400
                },
                screenshotOptions: {
                    viewportSize: {
                        width: 800,
                        height: 1066
                    },
                    paperSize: {
                        width: '4.75in',
                        height: '6.33in',
                        border: '0in'
                    },
                    zoomFactor: 1.0
                }
            },
            dataUrl1: {
                type: 'screenshot',
                options: {
                    y: 150,
                    x: 470,
                    cy: 533,
                    cx: 400
                },
                screenshotOptions: {
                    viewportSize: {
                        width: 800,
                        height: 1066
                    },
                    paperSize: {
                        width: '4.75in',
                        height: '6.33in',
                        border: '0in'
                    },
                    zoomFactor: 1.0
                }
            },
            square: {
                type: 'shape',
                shapeType: 'rect',
                options: {
                    y: 570,
                    x: 0,
                    cy: 115,
                    cx: 15,
                    line: 'FFFFFF',
                    color: 'FFFFFF',
                    fill: 'FFFFFF'
                }
            },
            brand: getBrandStyleInfo()
        }
    };

    // the versus double slide style/schema
    Slide.styles[Slide.styleTypes.VERSUS_DOUBLE] = {
        slide: {
            back: 'FFFFFF',
            color: '666666'
        },
        elements: {
            header: {
                type: 'header',
                options: {
                    y: 27,
                    x: 'c',
                    cy: 52,
                    cx: '95%'
                },
                title: {
                    type: 'text',
                    options: {
                        y: 27,
                        x: 'c',
                        cy: 52,
                        cx: '95%',
                        font_face: 'Arial',
                        font_size: 28,
                        color: '4C545E',
                        bold: false,
                        align: 'left'
                    }
                },
                secondaryTitle: {
                    type: 'text',
                    options: {
                        y: 69,
                        x: 'c',
                        cy: 52,
                        cx: '95%',
                        font_face: 'Arial',
                        font_size: 28,
                        color: '4C545E',
                        bold: false,
                        align: 'left'
                    }
                },
                subtitle: {
                    type: 'text',
                    multislideFormat: '{0} (Slide {1} of {2})',
                    options: {
                        y: 116,
                        x: 'c',
                        cy: 34,
                        cx: '95%',
                        font_face: 'Arial',
                        font_size: 16,
                        bold: false,
                        align: 'left'
                    }
                }
            },
            primaryMetric: {
                type: 'text',
                options: {
                    y: 568,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    bold: true,
                    font_size: 12,
                    align: 'left'
                }
            },
            primaryMetricDescription: {
                type: 'text',
                options: {
                    y: 586,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    font_size: 12,
                    align: 'left'
                }
            },
            secondaryMetric: {
                type: 'text',
                options: {
                    y: 624,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    bold: true,
                    font_size: 12,
                    align: 'left'
                }
            },
            secondaryMetricDescription: {
                type: 'text',
                options: {
                    y: 642,
                    x: 25,
                    cy: 28,
                    cx: 731,
                    color: '808080',
                    font_face: 'Arial',
                    font_size: 12,
                    align: 'left'
                }
            },
            dataUrl: {
                type: 'screenshot',
                options: {
                    y: 180,
                    x: 'c',
                    cy: 440,
                    cx: 880
                },
                screenshotOptions: {
                    viewportSize: {
                        width: 800,
                        height: 300
                    },
                    paperSize: {
                        width: '9.50in',
                        height: '4.8in',
                        border: '0in'
                    },
                    zoomFactor: 1.0
                }
            },
            square: {
                type: 'shape',
                shapeType: 'rect',
                options: {
                    y: 570,
                    x: 0,
                    cy: 115,
                    cx: 15,
                    line: 'FFFFFF',
                    color: 'FFFFFF',
                    fill: 'FFFFFF'
                }
            },
            brand: getBrandStyleInfo()
        }
    };

    // Creates an intro slide
    Slide.createIntro = function (dashboardModel, landscapeName, focusCompanyName) {
        return new Slide({
            style: Slide.styleTypes.INTRO,
            elements: Slide.getIntroElements(dashboardModel, landscapeName, focusCompanyName)
        });
    };

    Slide.getIntroElements = function (dashboardModel, landscapeName, focusCompanyName) {

        const elements = {
            head: dashboardModel.getPptTitle(),
            date: dashboardModel.getExportTitleBarTimePeriod(),
            brand: Slide.brandImages.getLarge()
        };

        if (focusCompanyName) {
            elements.focusCompanyTitle = 'Focus Company';
            elements.focusCompany = focusCompanyName;
        }

        const companySetDescriptor = dashboardModel.getProp('companySetDescriptor');
        if (companySetDescriptor) {
            elements.activeTagTitle = 'Company Set';
            elements.activeTag = RivalIQ.state.utils.getCompanySetName(companySetDescriptor);
            if (RivalIQ.state.utils.isOnlyCompanySet(companySetDescriptor)) {
                delete elements.focusCompany;
                delete elements.focusCompanyTitle;
            }
        }

        // if this landscape is not named default then use special formatting
        if (landscapeName.toLowerCase() !== 'default') {
            _.extend(elements, {
                landscapeTitle: 'Landscape',
                landscape: _.unescape(landscapeName)
            });
        }

        return elements;
    };

    // TODO global modification is dangerous
    Slide.customizeBrandImages = function (large, small) {
        const brandImages = Slide.brandImages;

        const getImage = function (image) {
            return function () {
                return (image.match(/^http/i)) ? image : RivalIQ.state.product.get('urlBasepath') + image;
            };
        };

        if (large) {
            brandImages.getLarge = getImage(large);
        }

        if (small) {
            brandImages.getSmall = getImage(small);
        }
    };

    function clone(input) {
        return JSON.parse(JSON.stringify(input));
    }

    function getBrandStyleInfo(isLarge, isCustom) {
        // Note: intentionally refusing to provide large brand images due to
        // resolution issues.
        const margin = isCustom ? 20 : 0;
        if (isLarge && !isCustom) {
            return {
                type: 'image',
                options: {
                    y: 427.8 - margin,
                    x: 428.4 - margin,
                    cy: 258,
                    cx: 486
                }
            };
        }
        return {
            type: 'image',
            options: {
                y: 602.325 - margin,
                x: 756.9 - margin,
                cy: 83.475,
                cx: 157.5
            }
        };
    }

    Slide.customizeStyles = function (forceSmallImages) {
        const styles = clone(Slide.styles);

        if (forceSmallImages) {
            // fix the brand image for each style
            _.each(styles, function (style) {
                style.elements.brand = getBrandStyleInfo(false, true);
            });
        }

        return styles;
    };
});
